import { Box, Inline, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import React from 'react';

const SHARED_SKELETON_HEIGHT = '15px';
const BORDER_RADIUS = 12;

const BASE_SKELETON_PROPS = {
  isShimmering: true,
  borderRadius: BORDER_RADIUS,
} as const;

export const StreamingSkeletonItem = () => {
  return (
    <Skeleton {...BASE_SKELETON_PROPS} width="85%" height={SHARED_SKELETON_HEIGHT} />
  );
};

const tableHeaderSkeletonStyles = xcss({
  width: '100%',
  gap: 'space.100',
  paddingInline: 'space.150',
  alignItems: 'center',
});

export const StreamingTableHeaderSkeletonItems = () => {
  return (
    <Inline xcss={tableHeaderSkeletonStyles}>
      <Skeleton {...BASE_SKELETON_PROPS} width="20px" height="20px" />
      <Skeleton {...BASE_SKELETON_PROPS} width="88%" height={SHARED_SKELETON_HEIGHT} />
    </Inline>
  );
};

export const StreamingCardTitleSkeletonItem = () => {
  return <Skeleton {...BASE_SKELETON_PROPS} width="100%" height="14px" />;
};

const fieldHeaderSkeletonStyles = xcss({
  paddingBlockStart: 'space.100',
});

export const StreamingCardFieldHeaderSkeletonItem = () => {
  return (
    <Box xcss={fieldHeaderSkeletonStyles}>
      <Skeleton {...BASE_SKELETON_PROPS} width="25%" height={SHARED_SKELETON_HEIGHT} />
    </Box>
  );
};

export const StreamingCardFieldValueSkeletonItem = () => {
  return (
    <Box paddingBlockStart="space.100">
      <Skeleton {...BASE_SKELETON_PROPS} width="75%" height={SHARED_SKELETON_HEIGHT} />
    </Box>
  );
};

const userFieldSkeletonStyles = xcss({
  alignItems: 'center',
  gap: 'space.075',
  paddingBlockStart: 'space.100',
});

export const StreamingCardUserFieldValueSkeletonItem = () => {
  return (
    <Inline xcss={userFieldSkeletonStyles}>
      <Skeleton {...BASE_SKELETON_PROPS} width="35%" height="14px" />
    </Inline>
  );
};

const StreamingCardFooterCommentSkeletonItem = () => {
  return <Skeleton isShimmering width="20px" height="20px" />;
};

const footerSkeletonStyles = xcss({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const StreamingCardFooterSkeletonItems = () => {
  return (
    <Box xcss={footerSkeletonStyles}>
      <Skeleton {...BASE_SKELETON_PROPS} width="30%" height="8px" />
      <StreamingCardFooterCommentSkeletonItem />
    </Box>
  );
};

export const StreamingCoverImageSkeletonItem = () => {
  return (
    <Box testId="streaming-cover-image-skeleton">
      <Skeleton {...BASE_SKELETON_PROPS} height="120px" width="100%" />
    </Box>
  );
};
